import { Link } from 'react-router-dom';

/**
 * SiteFooter — one subdued line across the base of every public and
 * signed-in page. Links to the legal pages and credits the publisher.
 *
 * Styling: slim type, muted color in both themes, hover underline.
 * Rendered as a `<footer>` so it sits semantically at the bottom of the
 * document outline. Pages that use min-h-screen flex layouts can mount
 * this at the end of their root container; pages that scroll freely can
 * mount it after their last section.
 */
const SiteFooter = ({ className = '' }) => {
  return (
    <footer
      data-testid="site-footer"
      className={`relative z-10 w-full py-6 px-6 border-t border-white/5 ${className}`}
    >
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3 text-[11px] font-mono uppercase tracking-widest text-zinc-500 opacity-60">
        <p>© HeroRocket Interactive LLC</p>
        <div className="flex items-center gap-5">
          <Link
            to="/terms"
            data-testid="footer-terms-link"
            className="hover:underline hover:text-zinc-300 transition-colors"
          >
            Terms
          </Link>
          <Link
            to="/privacy"
            data-testid="footer-privacy-link"
            className="hover:underline hover:text-zinc-300 transition-colors"
          >
            Privacy
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
